export const CheckCircleIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width={props.width ?? "24"}
      height={props.height ?? "24"}
      viewBox={props.viewBox ?? "0 0 24 24"}
      fill={props.fill ?? "none"}
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx={props.cx ?? "12"}
        cy={props.cy ?? "12"}
        r={props.r ?? "10"}
        stroke={props.stroke ?? "oklch(69.6% 0.17 162.48)"}
        strokeWidth={props.strokeWidth ?? "1.5"}
      />
      <path
        d="M8.5 12.5L10.5 14.5L15.5 9.5"
        stroke={props.stroke ?? "oklch(69.6% 0.17 162.48)"}
        strokeWidth={props.strokeWidth ?? "1.5"}
        strokeLinecap={props.strokeLinecap ?? "round"}
        strokeLinejoin={props.strokeLinejoin ?? "round"}
      />
    </svg>
  );
};
